import { CapabilityKey, CharacterFeature, SubCapabilityKey } from "@next-platform/packages-ts-types";
export const FEATURE_FILTER_OPTIONS = Object.freeze([
    { value: CharacterFeature.LOREBOOK, capability: CapabilityKey.Lorebook },
    { value: CharacterFeature.RULEBOOK, capability: CapabilityKey.Rulebook },
    { value: CharacterFeature.VOICE, capability: CapabilityKey.Tts },
    { value: CharacterFeature.CUSTOM_VOICE, capability: SubCapabilityKey.TtsCharacterAttach },
]);
const CHARACTER_FEATURE_VALUES = new Set(Object.values(CharacterFeature));
export const isCharacterFeature = (value) => CHARACTER_FEATURE_VALUES.has(value);
